import {
  LogoutOutlined,
  SettingOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Button, Dropdown, MenuProps, Typography } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  useNotificationInfinite,
  useReadNotification,
} from "../../query/NotiQuery";
import { AppDispatch } from "../../store";
import { RootState } from "../../store/index";
import { logout } from "../../store/slices/authSlice";
import { notify } from "../../utils/toast";
import MyAvatar from "../common/Avatar";
import Notification from "../common/Notification";
import ThemeToggle from "../common/ThemeToggle";

const Header: React.FC = () => {
  const user = useSelector((state: RootState) => state.auth.user);
  const userInfo = useSelector((state: RootState) => state.auth.userInfo);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { data, hasNextPage, isFetchingNextPage, fetchNextPage } =
    useNotificationInfinite();
  const readNotificationMutation = useReadNotification();
  const notifications = data?.pages.flatMap((p) => p.items) ?? [];
  const handleNotificationClick = async (id: number) => {
    await readNotificationMutation.mutateAsync(id);
  };

  const items: MenuProps["items"] = [
    {
      key: "profile",
      icon: <UserOutlined />,
      label: "Hồ sơ cá nhân",
      onClick: () => navigate("/profile"),
    },
    {
      type: "divider",
    },
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: <span>Đăng xuất</span>,
      onClick: async () => {
        await dispatch(logout());
        notify.success("Đăng xuất thành công");
        navigate("/login");
      },
    },
  ];

  return (
    <div
      className="flex justify-between items-center p-4 shadow-md"
      style={{ backgroundColor: "var(--bg-primary)" }}
    >
      <Typography.Title
        level={4}
        className="m-0 font-bold text-xl hidden md:block"
        style={{
          background: "var(--slogan-color)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          textTransform: "uppercase",
        }}
      >
        <span className="text-primary">pursuing perfection</span>
      </Typography.Title>

      <Typography.Title
        level={5}
        className="m-0 font-bold text-sm md:hidden"
        style={{
          background: "var(--slogan-color)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          textTransform: "uppercase",
        }}
      >
        <span className="text-primary"></span>
      </Typography.Title>

      <div className="flex items-center gap-2 sm:gap-3 md:gap-4 transition-colors duration-300">
        <Notification
          onNotificationClick={(notification) => {
            handleNotificationClick(notification.id);
          }}
          notifications={notifications}
          hasNextPage={hasNextPage}
          isFetching={isFetchingNextPage}
          onLoadMore={fetchNextPage}
        />
        <Button
          shape="circle"
          icon={<SettingOutlined />}
          size="large"
          className="hidden sm:flex"
        />
        <ThemeToggle />
        <Dropdown menu={{ items }} placement="bottomRight">
          <span className="cursor-pointer flex items-center">
            {userInfo ? (
              <MyAvatar name={userInfo.fullName} userInfo={userInfo} />
            ) : (
              <MyAvatar name={user?.user?.fullName || ""} />
            )}
            <span className="ml-2 hidden sm:inline">
              {user?.user?.fullName}
            </span>
          </span>
        </Dropdown>
      </div>
    </div>
  );
};

export default Header;
